import { gql } from '@apollo/client';

export const FETCH_LOGIN_TIKTOK_URL = gql`
  query authTiktokUrl {
    authTiktok {
      redirectTo
    }
  }
`;
